module.exports = __webpack_public_path__ + "static/media/0.992ba255.jpg";